// js
import Overlap from '../../components/analytics/Overlap';
import { connect } from 'react-redux';
import { makeGetAreaOverlapTotals, makeGetAreaOverlap } from '../../selectors/analytics/overlapSelectors';


const mapStateToProps = (state) => {
  const getAreaOverlapTotals = makeGetAreaOverlapTotals();
  const getAreaOverlap = makeGetAreaOverlap();

  return {
    overlapStatTotals: getAreaOverlapTotals(state),
    overlapStats: getAreaOverlap(state)
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Overlap);



// WEBPACK FOOTER //
// ./src/containers/analytics/Overlap.js